var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":_vm.$t('expense_report')}}),_vm._v(" "),_c('app-table',{attrs:{"id":_vm.tableId,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }